import React, { useState, useContext } from "react";

import UserContext from "../../context/UserContext";
import { Form, Button } from "react-bootstrap";
import Axios from "axios";
import ErrorNotice from "../../misc/ErrorNotice";
import { API_URL } from "../../constants";

function SignUp() {
  const [name, setName] = useState();
  const [number, setNumber] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [passwordCheck, setPasswordCheck] = useState();
  const [displayName, setDisplayName] = useState();
  const { setUserData } = useContext(UserContext);

  const [error, setError] = useState();

  const submit = async (e) => {
    e.preventDefault();
    try {
      const newUser = {
        name,
        number,
        email,
        password,
        passwordCheck,
        displayName,
      };
      const url1 = `${API_URL}/api/user/SignUp`;
      await Axios.post(url1, newUser);
      const url2 = `${API_URL}/api/user/SignIn`;
      const loginRes = await Axios.post(url2, {
        email,
        password,
      });
      setUserData({
        token: loginRes.data.token,
        user: loginRes.data.user,
      });
      window.location.href = "/";
      localStorage.setItem("auth-token", loginRes.data.token);
    } catch (err) {
      err.response.data.msg && setError(err.response.data.msg);
    }
  };

  return (
    <>
      <>
        <div className="SignUp my-2 ">
          <h2 className="text-center text-dark ">
            <b>Sign-Up</b>
          </h2>
          <br />
          <div
            className="formm container"
            style={{ border: "groove", padding: "3% 3% 3% 3% " }}
          >
            {error && (
              <ErrorNotice
                message={error}
                clearError={() => setError(undefined)}
              />
            )}
            <Form onSubmit={submit}>
              <Form.Group controlId="formBasicText">
                <Form.Label>Enter Your Name:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Name"
                  onChange={(e) => setName(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formBasicText">
                <Form.Label>Enter Your Number:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Number"
                  onChange={(e) => setNumber(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Form.Text className="text-muted">
                  We'll never share your email with anyone else.
                </Form.Text>
              </Form.Group>

              <Form.Group controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formBasicPassword">
                <Form.Control
                  type="password"
                  placeholder="Verify Password"
                  onChange={(e) => setPasswordCheck(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formBasicText">
                <Form.Label>Display Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Display Name"
                  onChange={(e) => setDisplayName(e.target.value)}
                />
              </Form.Group>
              <Form.Group controlId="formBasicCheckbox"></Form.Group>
              <br />
              <Button variant="dark" type="submit">
                Submit
              </Button>
            </Form>
          </div>
        </div>
      </>
    </>
  );
}

export default SignUp;
